import { AccountModel, BillStatusInfo } from './AccountModel';
import { ProductModel } from './selfcareproducts';

export interface CustomerModel  
    {
        ProspectID: number;
        i_customer: number;
        ID: IdentificationInfo;
        Salutation: string;
        FirstName: string;
        LastName: string;
        MiddleInitial: string;
        EmailAddress:   string   ,
        MobilePhone: string;
        HomePhone: string;
        /**for corporate customer, though may be provided by individual customer too */
        TIN: string;
        Address: AddressInfo;
        DateOfBirth: Date | string | null;
        Anniversary: Date | string | null;
        PrimaryContact: string;
        Gender: string;
        NextOfKin: NextOfKinInfo;
        SpouseName: string;
        Office: OfficeInfo;
        ContactMethod: ContactMethods;
        block: BlockStatus | null;
        CreditLimit: number | null;
        CreditLimitSpecified: boolean;
        TemporaryCreditLimmit: TemporaryCreditLimitInfo;
        CreationDate: Date | string;
        BillStatus: BillStatusInfo;
        Accounts: AccountModel[];
        PortaBillingCreditable: boolean;
        CustomerCategory: CustomerCategoryInfo;
        CustomerClass: CustomerClassInfo;
        Balance: number | null;
        CustomerServiceType: CustomerServiceTypeInfo;
        /**Commented to disallow abuse of the credentials during customer detail fetch */
        //PortaoneCredential: PortaoneCustomerCredentialInfo;

        /**this value will become the CustomerInfo.name */
        CustomerName: string;

        /**1 for Cyberspace customers and 4 for Visafone customers */
        OperatorCode: number;
        notepad: string;
        EmailUnsubscribe: boolean | null;
        SMSUnsubscribe: boolean | null;
        AccountOfficer: AccountOfficerInfo;

        KYCStatus: number | null;
        DealerID: number | null;
        isDealer: boolean | null;
        AirTimeCommission: number | null;

        ShareCategory: SharingCategory;

        DefaultProduct: ProductModel;
        BatchNo: string;
        ReferralActivationCode: string;
        ReferralCode: string;
        FollowUp: boolean;
        BillingBalance: number | null;
        Session: string;
        Referree_i_customer: number;
        CreatedDate:Date;
        CreatedBy:string;
        DealerUserID:string;
        Equals(other: CustomerModel): boolean;
    }
 
    export interface AccountOfficerInfo
    {
        Name: string;
        EmailAddress: string;
        MobilePhone: string;
    }

    export interface CustomerRequestModel    {
        Customer: CustomerModel;
        Account: AccountModel;
        Product: ProductModel;
        StartDate: Date | string;
        EndDate: Date | string;
        Limit: number;
        Agent: string;
        Dealer: string;
        Location: string;
        OperatorCode: number;
    }

    export interface PortaoneCustomerCredentialInfo
    {
        PortaoneUsername: string;
        PortaonePassword: string;
    }

    /**
     * This is for classification of customers for marketting and support purposes and will be managed from Admin interface but must be specified and during customer creation    
     */
    export interface CustomerCategoryInfo
    {
        ID: string;
        Name: string;
    }

    export interface CustomerClassInfo
    {
        ID: number;//1 retail, 2 enterprise, 3 demo for NAVISION
        Name: string;
    }
    export interface CustomerServiceTypeInfo
    {
        ID: number;//1 LTE, 2 NON-LTE
        Name: string;
    }

    export interface NextOfKinInfo
    {
        Name: string;
        Relationship: string;
        Telephone: string;
        Address: string;
        Occupation: string;
    }

    export interface OfficeInfo
    {
        Occupation: string;
        Company: string;
        Address: string;
        Telephone: string;
    }

    export interface AddressInfo
    {
        Street: string;
        Area: string;
        City: string;
        State: string;
        Country: string;
        Zip: string;
    }

    export interface IdentificationInfo
    {
        IdentificationTypeID: number;
        Type: IdentificationType;
        CardNumber: string;
    }

    export enum IdentificationType { DriverLicence, InternationalPassport, NationalIDCard, CACRegCertificate }

    export enum RequestFromType {
        //CRM, MOBILE, WEB, System, JOB, DealershipPortal, Bank, ExternalCommApi, Any
        CRM = 100000000,
        MOBILE,
        WEB = 100000002,
        System,
        Bank = 100000005,
        JOB,
        DealershipPortal,
        ExternalCommApi,
        Any

    }
    export enum SharingCategory {
        //None, SingleSum, TotalSum
        None = 0,
        SingleSum = 100000000,
        TotalSum = 100000001,
    }



    export interface ContactMethods
    {
        Type: ContactType;
        PreferredPhone: PreferredPhoneType;
    }
    export enum ContactType { Email = 1, Telephone = 2, SMS = 3 }

    export enum PreferredPhoneType { HomePhone = 1, MobilePhone = 2, WorkPhone = 3 }

    export enum BlockStatus { Y, N }

    export interface TemporaryCreditLimitInfo
    {
        CreditLimt: number;
        ExpirationDate: Date | string;
    }

    export interface CustomerBatchInfo
    {
        FirstName: string;
        LastName: string;
        EmailAddress: string;
        MobilePhone: string;
        HomePhone: string;
        AddressStreet: string;
        AddressArea: string;
        AddressCity: string;
        AddressState: string;
        AddressCountry: string;
        AddressZip: string;
        i_customer: number;
        ErrorMessage: string;
    }

    export interface CustomerBatchInfoModel
    {
        Customers: CustomerBatchInfo[];
        RequestFrom: RequestFromType;
        Createdby: string;
        Password: string;
        OperatorCode: number;
    }